export const TRANSLATIONS_SETTINGS = {
  title: 'csp.setting.index',
  cancel: 'button.cancel',
  save: 'button.save_changes',
  pageLayout: {
    plan: 'csp.my_plan',
    profile: 'csp.my_profile',
    organization: 'csp.my_organization',
    integrations: 'csp.my_integrations',
    account: 'csp.my_account',
    title: 'settings.title',
    subtitle: 'settings.subtitle'
  },
  avatar: {
    edit: 'button.change_photo',
    delete: 'button.remove_photo',
    upload: 'button.upload_photo'
  },
  personalData: {
    title: 'profile.personal_data',
    name: 'csp.name',
    lastName: 'csp.last_name',
    email: 'login.email',
    phone: 'csp.phone'
  },
  error: {
    buttonText: 'button.close',
    image: {
      snackbarTitle: 'snackbar.error.profile_photo.title',
      size: 'snackbar.error.profile_photo.description.size',
      format: 'snackbar.error.profile_photo.description.format',
      generic: 'snackbar.error.profile_photo.description.default'
    },
    personalData: {
      snackbarTitle: 'profile.personal_data',
      description: 'snackbar.error.profile_data.description'
    },
    lenguageSelector: {
      snackbarTitle: 'profile.language_selector',
      description: 'snackbar.error.language_selector.description'
    },
    title: 'csp.loading_error.title',
    subtitle: 'csp.empty_state.subtitle'
  },
  success: {
    buttonText: 'button.close',
    image: {
      snackbarTitle: 'snackbar.error.profile_photo.title',
      description: 'snackbar.success.profile_photo.description'
    },
    personalData: {
      snackbarTitle: 'profile.personal_data',
      description: 'snackbar.success.profile_data.description'
    },
    lenguageSelector: {
      snackbarTitle: 'profile.language_selector',
      description: 'snackbar.success.language_selector.description'
    }
  },
  password: {
    title: 'login.password',
    buttonText: 'button.change_pass',
    lastModification: 'profile.last_modification',
    modal: {
      title: 'modal.profile.change_pass.title',
      currentPassword: 'profile.current_password',
      newPassword: 'login.new_password',
      conditions: 'login.activation.conditions_pasword',
      changePassButton: 'button.change_pass',
      confirmPassword: 'login.confirm_password',
      notMatchPassword: 'login.alert.passwords_not_match',
      cancelButton: 'button.cancel',
      errorPassword: 'profile.incorrect_current_pass'
    }
  },
  businessData: {
    holding: 'csp.holding',
    company: 'csp.company',
    action: 'csp.action',
    edit: 'button.edit',
    lastUpdate: 'csp.last_update_date',
    modal: {
      title: {
        holding: 'modal.profile.edit_holding.title',
        company: 'modal.profile.edit_company.title'
      },
      subtitle: {
        holding: 'modal.profile.edit_holding.subtitle',
        company: 'modal.profile.edit_company.subtitle'
      },
      name: {
        holding: 'profile.holding_name',
        company: 'profile.company_name'
      },
      logo: {
        holding: 'profile.holding_logo',
        company: 'profile.company_logo'
      },
      saveButton: 'button.save_changes',
      cancelButton: 'button.cancel'
    }
  },
  plan: {
    includes: 'plan.services.includes',
    plan: 'csp.plan',
    benefits: {
      title: 'csp.benefits',
      subtitle: 'plan.service.full_benefits.description'
    },
    insurance: {
      title: 'csp.insurance',
      subtitle: 'plan.service.insurance.description'
    },
    marketplace: {
      title: 'csp.marketplace',
      subtitle: 'plan.service.has_marketplace.description'
    },
    summaryTable: {
      title: 'plan.monthly_fee',
      subtitle: 'plan.service.main',
      costPerEmployee: 'plan.cost.per_employees'
    }
  },
  integrations: {
    slack: {
      title: 'integrations.slack.title',
      descriptionDisconnected: 'integrations.slack.description_disconnected',
      buttonDisconnected: 'integrations.slack.button_disconnected',
      descriptionConnected: 'integrations.slack.description_connected',
      statusCardConnected: 'integrations.slack.status_card_connected',
      buttonConnected: 'integrations.slack.button_connected',
      titleSuccessModal: 'integrations.slack.title_success_modal',
      textSuccessModal: 'integrations.slack.text_success_modal',
      buttonSuccessModal: 'integrations.slack.button_success_modal',
      titleErrorModal: 'integrations.slack.title_error_modal',
      textErrorModal: 'integrations.slack.text_error_modal',
      buttonErrorModal: 'integrations.slack.button_error_modal'
    }
  },
  languageSelector: {
    title: 'profile.language_selector'
  }
};
